export default "__VITE_ASSET__DuruCsiS__"